import cx from "classnames";
import { Container } from "modules/layout";
import Link from "next/link";
import Router, { useRouter } from "next/router";
import { FinancesEducationLayout } from "pages/[company]/finances/education/_layout";
import pages from "pages/_router";
import React from "react";
import { api } from "shared/api";
import { Button } from "shared/ui";
import styles from "./table-of-content.module.scss";

const list = [
  "Что такое финансовое планирование?",
  "Построим финансовую модель",
  "Задача: Укажите ваши переменные и постоянные расходы",
  "Считаем расходы",
  "Задача: Укажите ваши переменные и постоянные расходы",
  "Чем прибыльная компания отличается от неприбыльной?",
  "Задача: Заложите в фин. модель отчисления на резерв и возврат инвестиций",
  "Точка безубыточности-2 и система фондов",
  "План бюджета на месяц",
  "Создадим бюджет на месяц на основе финансовой модели",
  "Задача: Составьте бюджет на месяц",
  "Как добиться выполнения плана?",
  "Контроль трат. Заявки на расход и выплаты.",
  "Каждую неделю – еженедельное финансовое планирование",
  "Итоги",
];

const TableOfContentPage = () => {
  const companySlug = useRouter().query.company as string;
  const educationRouter = pages.company(companySlug).finances.education;

  const settings = api.financeSettings.useFinanceSettingsGet(companySlug);

  const onContinue = async () => {
    if (!settings.data) return;

    if (settings.data.educationStep < 1) {
      await api.financeSettings.financeSettingsUpdateEducationStep(companySlug, {
        educationStep: 1,
      });
      await Router.push(educationRouter.step(1).href);
      return;
    }

    await Router.push(educationRouter.step(settings.data.educationStep).href);
  };

  return (
    <FinancesEducationLayout>
      <Container className={styles.table_of_content}>
        <div className={styles.inner}>
          <h1>Оглавление</h1>
          <div className={styles.list}>
            {list.map((it, key) => {
              const active = key < settings.data?.educationStep!;

              const step = key + 1;
              const href = educationRouter.step(step).href;
              const Wrapper = active ? Link : "div";

              return (
                <Wrapper href={href} className={cx(styles.item, active && styles.active)} key={step}>
                  <div className={styles.number}>{step}.</div>
                  <div className={styles.name}>{it}</div>
                </Wrapper>
              );
            })}
          </div>

          <hr />

          <div className={styles.actions}>
            <Button onClick={onContinue}>Продолжить</Button>
          </div>
        </div>
      </Container>
    </FinancesEducationLayout>
  );
};

export default TableOfContentPage;
